// =============================================================================
// Austrian public holidays (gesetzliche Feiertage), generated from rules so
// they never need a data file. Nine are fixed dates; the rest hang off
// Easter, which is computed with the Gregorian computus (Meeus/Jones/Butcher).
// Sundays (Ostersonntag, Pfingstsonntag) are not listed — they are Sundays.
// =============================================================================

import { format } from 'date-fns';

// Easter Sunday for a Gregorian year, as a local Date.
export const easterSunday = (year) => {
  const a = year % 19;
  const b = Math.floor(year / 100);
  const c = year % 100;
  const d = Math.floor(b / 4);
  const e = b % 4;
  const f = Math.floor((b + 8) / 25);
  const g = Math.floor((b - f + 1) / 3);
  const h = (19 * a + b - d - g + 15) % 30;
  const i = Math.floor(c / 4);
  const k = c % 4;
  const l = (32 + 2 * e + 2 * i - h - k) % 7;
  const m = Math.floor((a + 11 * h + 22 * l) / 451);
  const month = Math.floor((h + l - 7 * m + 114) / 31); // 3 = March, 4 = April
  const day = ((h + l - 7 * m + 114) % 31) + 1;
  return new Date(year, month - 1, day);
};

const plusDays = (date, n) => new Date(date.getFullYear(), date.getMonth(), date.getDate() + n);

// Names in both app languages; `id` is stable across years so a holiday can
// be keyed and looked up.
const HOLIDAYS = [
  { id: 'neujahr', month: 1, day: 1, de: 'Neujahr', en: "New Year's Day" },
  { id: 'dreikoenig', month: 1, day: 6, de: 'Heilige Drei Könige', en: 'Epiphany' },
  { id: 'ostermontag', easter: 1, de: 'Ostermontag', en: 'Easter Monday' },
  { id: 'staatsfeiertag', month: 5, day: 1, de: 'Staatsfeiertag', en: 'Labour Day' },
  { id: 'himmelfahrt', easter: 39, de: 'Christi Himmelfahrt', en: 'Ascension Day' },
  { id: 'pfingstmontag', easter: 50, de: 'Pfingstmontag', en: 'Whit Monday' },
  { id: 'fronleichnam', easter: 60, de: 'Fronleichnam', en: 'Corpus Christi' },
  { id: 'mariae-himmelfahrt', month: 8, day: 15, de: 'Mariä Himmelfahrt', en: 'Assumption Day' },
  { id: 'nationalfeiertag', month: 10, day: 26, de: 'Nationalfeiertag', en: 'National Day' },
  { id: 'allerheiligen', month: 11, day: 1, de: 'Allerheiligen', en: "All Saints' Day" },
  { id: 'mariae-empfaengnis', month: 12, day: 8, de: 'Mariä Empfängnis', en: 'Immaculate Conception' },
  { id: 'christtag', month: 12, day: 25, de: 'Christtag', en: 'Christmas Day' },
  { id: 'stefanitag', month: 12, day: 26, de: 'Stefanitag', en: "St. Stephen's Day" }
];

// All Austrian public holidays of `year`, sorted, as
// { id, date: 'yyyy-MM-dd', name } with `name` in the given language.
export const austrianHolidays = (year, lang = 'de') => {
  const easter = easterSunday(year);
  return HOLIDAYS.map((h) => {
    const date = h.easter != null ? plusDays(easter, h.easter) : new Date(year, h.month - 1, h.day);
    return { id: h.id, date: format(date, 'yyyy-MM-dd'), name: lang === 'en' ? h.en : h.de };
  }).sort((a, b) => a.date.localeCompare(b.date));
};

// Holidays for every year in [fromYear, toYear], flattened.
export const austrianHolidaysBetween = (fromYear, toYear, lang = 'de') => {
  const out = [];
  for (let y = fromYear; y <= toYear; y++) out.push(...austrianHolidays(y, lang));
  return out;
};
